"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.JastBuilder = void 0;
const JastBuildingParseTreeVisitor_1 = require("./JastBuildingParseTreeVisitor");
const jql_grammar_1 = require("@atlassiansox/jql-grammar");
const antlr4ts_1 = require("antlr4ts");
const JastBuilderErrorListener_1 = __importDefault(require("./errors/JastBuilderErrorListener"));
const memoize_one_1 = __importDefault(require("memoize-one"));
class JastBuilder {
    constructor() {
        this.errorListeners = [];
        this.errorHandler = undefined;
        this.getTokens = memoize_one_1.default((value) => {
            const chars = antlr4ts_1.CharStreams.fromString(value);
            const lexer = new jql_grammar_1.JQLLexer(chars);
            return new antlr4ts_1.CommonTokenStream(lexer);
        });
        this.getParser = memoize_one_1.default((tokens) => new jql_grammar_1.JQLParser(tokens));
    }
    setErrorHandler(errorHandler) {
        this.errorHandler = errorHandler;
        return this;
    }
    setErrorListeners(errorListeners) {
        this.errorListeners = this.errorListeners.concat(errorListeners);
        return this;
    }
    build(value) {
        const tokens = this.getTokens(value);
        const parser = this.getParser(tokens);
        const astErrorListener = new JastBuilderErrorListener_1.default();
        parser.removeErrorListeners();
        parser.addErrorListener(astErrorListener);
        this.errorListeners.forEach(errorListener => parser.addErrorListener(errorListener));
        if (this.errorHandler) {
            parser.errorHandler = this.errorHandler;
        }
        const visitor = new JastBuildingParseTreeVisitor_1.JastBuildingQueryVisitor(tokens);
        try {
            const parseTree = parser.query();
            const query = parseTree.accept(visitor);
            return {
                query,
                errors: astErrorListener.errors
            };
        }
        catch (e) {
            // TODO instrument this so we can monitor any parse failures
            console.log('parse tree error ', e);
        }
        return {
            query: undefined,
            errors: []
        };
    }
}
exports.JastBuilder = JastBuilder;
//# sourceMappingURL=JastBuilder.js.map